import { Link, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import ContentLayout from "studio-edifique/components/ContentLayout";
import ResponsiveImage from "studio-edifique/components/ResponsiveImage";
import NotFoundPage from "studio-edifique/pages/NotFoundPage";
import {
  caseStudies,
  servicePages,
  company,
  getSiteUrl,
  getAssetUrl,
} from "studio-edifique/siteContent";

function ProjectPage() {
  const { slug } = useParams();
  const project = caseStudies.find((item) => item.slug === slug);
  if (!project) return <NotFoundPage />;
  const service = servicePages.find((item) => item.slug === project.serviceSlug);
  const schema = {
    "@context": "https://schema.org",
    "@type": "CreativeWork",
    name: project.title,
    description: project.description,
    url: getSiteUrl(`/projetos/${project.slug}`),
    image: project.gallery.map((image) => getAssetUrl(image.src)),
    creator: { "@type": "Organization", name: company.brandName, url: company.siteUrl },
  };
  return (
    <ContentLayout
      title={project.title}
      description={project.description}
      intro={project.description}
      eyebrow={project.mediaLabel}
      image={project.cover}
      imageAlt={`${project.title} — ${project.mediaLabel.toLowerCase()}`}
      parent={{ name: "Portfólio", path: "/portfolio" }}
      schema={[schema]}
    >
      <MKBox component="section" maxWidth="52rem" mb={5}>
        <MKTypography variant="h3" component="h2" mb={2}>
          Contexto da proposta
        </MKTypography>
        <MKTypography variant="body1" color="text" mb={4}>
          {project.challenge}
        </MKTypography>
        <MKTypography variant="h3" component="h2" mb={2}>
          Soluções e leitura do trabalho
        </MKTypography>
        <MKTypography variant="body1" color="text" mb={4}>
          {project.solution}
        </MKTypography>
        <MKTypography variant="h4" component="h2" mb={2}>
          Escopo apresentado
        </MKTypography>
        <MKTypography variant="body1" color="text" mb={2}>
          {project.scope}
        </MKTypography>
        <MKTypography variant="body2" color="text">
          {project.scopeNote}
        </MKTypography>
      </MKBox>
      <MKBox component="section">
        <MKTypography variant="h3" component="h2" mb={3}>
          {project.mediaLabel}
        </MKTypography>
        <Grid container spacing={3}>
          {project.gallery.map((image, index) => (
            <Grid item xs={12} md={6} key={image.src}>
              <MKBox component="figure" m={0}>
                <ResponsiveImage
                  src={image.src}
                  alt={`${project.title} — ${project.mediaLabel.toLowerCase()}, imagem ${
                    index + 1
                  }`}
                  sizes="(max-width: 900px) 100vw, 50vw"
                />
                <MKTypography
                  component="figcaption"
                  variant="caption"
                  color="text"
                  display="block"
                  mt={1}
                >
                  {project.mediaLabel} · {index + 1}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </MKBox>
      <MKBox component="section" mt={6}>
        <MKTypography variant="h3" component="h2" mb={2}>
          Planeje seu projeto com a equipe
        </MKTypography>
        <MKTypography variant="body1" color="text" mb={3}>
          Conheça o serviço relacionado e converse sobre as necessidades do seu imóvel ou da sua
          obra em Itatiba e região.
        </MKTypography>
        <MKButton component={Link} to={`/servicos/${service.slug}`} color="info" variant="outlined">
          {service.name}
        </MKButton>
      </MKBox>
    </ContentLayout>
  );
}
export default ProjectPage;
